import * as React from 'react';
const classNames = require('classnames');

const BUTTONSSECTION_USAGE = {
	portal: '',
	admin: 'buttonsSectionAdmin',
};

interface IProps {
	usage?: 'portal' | 'admin';
	align?: 'left' | 'right' | 'justify' | 'stretch';
	showTopLine?: boolean;
	children?: any;
	customClassName?: string;
}

/**
 *
 * @param props
 */
export const ButtonsSection = (props: IProps) => {
	const usage = props.usage ? BUTTONSSECTION_USAGE[props.usage] : BUTTONSSECTION_USAGE.portal;
	return (
		<div
			className={classNames(
				'buttonsSection align-' + (props.align || 'left'),
				usage,
				{
					['showTopLine']: props.showTopLine === true,
				},
				props?.customClassName,
			)}
		>
			{props.children}
		</div>
	);
};
